module.exports = __webpack_public_path__ + "img/ico_p_pass.602d6c3.svg";